module.exports = __webpack_public_path__ + "img/IMG_9257_T_L_Black_MockedUp.9efaf5d8.jpg";